import { linkToTeacherDashboard } from "../../links";

export function linkToResourcesHub() {
  return `${linkToTeacherDashboard()}/resources`;
}
